import * as Yup from 'yup';

export const editSupplierSettingsSchema = () => {
  return Yup.object().shape({
    vat_percentage: Yup.number()
      .required('VAT percentage is required')
      .min(0, 'VAT percentage must be at least 0')
      .max(100, 'VAT percentage must be at most 100'),
    pricing_currency: Yup.string()
      .required('Currency is required')
      .max(3, 'Currency code must have maximum 3 characters'),
    order_prefix: Yup.string()
      .required('Order prefix is required')
      .max(10, 'Order prefix must have maximum 10 characters'),
  });
};
